import './Branding.css';
import React , {Component} from 'react';
import image1 from '../../../../src/images/branding_image_1.jpg';
import image2 from '../../../../src/images/branding_image_2.jpg';
function Branding(){
    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    <div className='title'>
                        <div className='info'>
                            <h2 className='py-3'>بیانیه برندینگ</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row bottom-box pt-5'>
                <div className='col-12 col-md-6'>
                    <img  src={image1}/>
                </div>
                <div className='col-12 col-md-6'>
                    <p>جایی در مسیر مستقیم اما پرفرازونشیب روزمرگی، ناگهان نیازی متفاوت در ذهن انسان جرقه می‌زند؛ نیاز به مواجهه‌ با چیزی و جایی ناشناخته؛ به جایی برای تنهابودن، به رفتنی به‌قصد توسعه‌ کسب‌وکار یا به زمانی برای بودن و تماشای طبیعت.
از میان هزاران مقصد، اقامتگاه و وسیله آمدورفتن، مقصدی برای دورشدن از روزمرگی، جایی برای اقامتی مطلوب و وسیله‌ای برای رسیدن و بازگشتن را انتخاب می‌کنیم و درنهایت، هرکدام آنچه از سفر می‌خواهیم را به‌گونه‌‌ای متفاوت درمی‌یابیم. یکی در تنهایی و دیگری در جمع، یکی در شهری تاریخی و دیگری در کنار تالابی کوچک. ذهن یکی را باریکه‌های نوری که از میان درختان یک جنگل تابیده روشن می‌کند و ذهن دیگری را ستارگان آسمان شبِ کویر.
سفر برای هرکدام از ما به‌شکلی منحصربه‌فرد معنی می‌شود و با سبک‌های متفاوت اما هم‌زمان پیش می‌رود، تا جایی که سرزمینی از تنوع و رنگ و نشانه ساخته شود و آسمانی از علائق و سلائق.
گویی باید پذیرفت که این «زندگی و سفر در کهکشانی از جهان‌های موازیِ متفاوت» است که به هستی معنا می‌بخشد.</p>
                </div>
                <div className='col-12 col-md-6 mt-5'>
                    <p>
روشنیِ مسیر پیشِ روی علی‌بابا در بازطراحی هویتش از نوری می‌آید که «کهکشان متفاوت‌زیستن» بر حرف ابتدایی نامِ علی‌بابا تابانده؛ حرفی که با نقشی جدید، از این به بعد لوگو و نشان ماست.
لوگوی تازه، یک نشانه ثابت و ایستا نیست؛ بلکه طیف وسیعی از طرح‌هاست که بسته به موقعیت‌های ارتباطی متحول می‌شود.
حضور علی‌بابا در جهان‌های متفاوت سفر که هم‌زمان با هم و به فراخور نیازهای متنوع هر مسافر بروز و ظهور می‌یابند، به طراحی طیف گسترده‌ای از طرح‌ها ترجمه شده تا هویت جدید برند علی‌بابا با خاصیت «تحول مداوم سفر» منطبق و هم‌راستا باشد.
از این پس، هر لحظه و متناسب با فضای هر سفر، نیاز مسافر و جنس فعالیت ارتباطی، جامه‌هایی متنوع بر تن لوگوی جدید علی‌بابا پوشانده خواهد شد که هرکدام از آن جامه‌ها بتوانند در لحظه معرف روح، معنی و فضای متفاوتی باشند.</p>
                </div>
                <div className='col-12 col-md-6 mt-5'>
                    <img  src={image2}/>
                </div>
                <div className='col-12 col-md-6 mt-5'>
                    <span>آنچه ما را به سمت داشتن ایده هویت پویا سوق می دهد:</span>
                    <ul className='list'>
                        <li class="btn btn-primary my-1">تطابق با بستری که تعاملو گفتگو در آن رخ می دهد</li>
                        <li class="btn btn-primary my-1">هم خوانی با ذات پویا و نوآفرین خود علی بابا</li>
                        <li class="btn btn-primary my-1">هماهنگی با مفهوم پویا و همیشه زنده سفر</li>
                    </ul>
                </div>
                <div className='col-12 col-md-6 mt-5'>
                    <p>
                    ما امروز در روزی که مثل همیشه «روز اول» است، در مسیر جدیدی قدم گذاشته‌ایم تا سفر را از سه‌گانه‌ «رفتن، ماندن و بازگشتن» به مفهومی وسیع‌تر، به‌اندازه دنیاهای پر از تفاوتمان گسترش دهیم. می‌خواهیم مثل همیشه همسفرِ سفری باشیم که از دامنه خیال تا مرور خاطرات شیرین وسعت دارد.</p>
                </div>
            </div>
        </div>
    )
}
export default Branding;